import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnboardingService } from '../onboarding.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  form: FormGroup;

  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type: 'image' | 'audio';
  @ViewChild('progressDialog', { static: true }) secondDialog: TemplateRef<any>;
  isCaptchaDisabled:boolean=environment.captchaDisabled;
  resetForm!: FormGroup;
  submitted = false;
  verifyForm!: FormGroup;
  emailVerified: boolean = false;
  resend: any;
  userDetails: any;
  timer: any = 30;
  errorMessage: any;
  showErrMsg: boolean = false;
  constructor(private fb: FormBuilder, private onboardingService: OnboardingService,
    private router: Router, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      emailAddress: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')])],
      captchaResponse: ['', this.isCaptchaDisabled ?null:Validators.required]


    });
    this.verifyForm = this.fb.group({
      verificationCode: ['', Validators.compose([Validators.required])]
    });

  }

  get resetFormControl() {
    return this.resetForm.controls;
  }

  get verifyFormControlItem() {
    return this.verifyForm.controls;
  }


  onSubmit() {
    this.submitted = true;
    if (this.resetForm.dirty && this.resetForm.valid) {
      console.log(this.resetForm.value);
      this.dialog.open(this.secondDialog,{disableClose: true})
      // this.emailVerified = true;
      this.onboardingService.verifyEmail(this.resetForm.value).subscribe((res) => {
        console.log(res)
        this.dialog.closeAll()
        if (res) {
          this.emailVerified = true;
          this.userDetails = res.body;
          this.submitted = false;
          this.showErrMsg = false;
          const interval = setInterval(() => {
            this.timer = this.timer - 1;
            if (this.timer <= 0) {
              clearInterval(interval);
              this.resend = true
            }
          }, 1000)
        }
      }, err => {
        console.log(err.error)
        this.dialog.closeAll()
        if (err == 500) {
          this.errorMessage = "Email address is not registered, please enter a registered email OR create a new account";
          this.showErrMsg = true;
          this.submitted = false;
          this.resetForm.reset()
        }
      })
    }
  }

  handleSuccess(data) {
    console.log(data);
  }

  errored(event) {
    console.log('error', event)
  }

  get verifyFormControl() {
    return this.verifyForm.controls;
  }


  resendVerficationEmail() {
    this.timer = 30;
    this.resend = false
    const interval = setInterval(() => {
      this.timer = this.timer - 1;
      if (this.timer <= 0) {
        clearInterval(interval)
        this.resend = true
      }
    }, 1000)
    this.onboardingService.resendForgotPassword(this.userDetails.userId).subscribe((res) => {
      console.log(res)
    }, err => {

    })
  }

  verifyCode() {
    this.submitted = true;
    if (this.verifyForm.valid) {
      const obj = {
        "emailAddress": this.resetForm.value.emailAddress,
        "verificationCode": this.verifyForm.value.verificationCode
      }
      this.onboardingService.resetPassword(obj).subscribe((res: any) => {
        if (res) {
          // this.
          this.router.navigate(['/setup-password'], { state: { token: res.token, email: this.resetForm.value.emailAddress } })
        }
      }, err => {
        console.log(err)
        if (err == 500) {
          this.errorMessage = "Please provide valid code";
          this.showErrMsg = true;
          this.submitted = false;
          this.verifyForm.reset()
        }
      })
    }

  }

  navigateSignUp(){
    this.router.navigate(['/signup'])
  }

}
